// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { colors, tabletThresholdPixels } from '../../home/v4/styledComponents';
import { toFormattedBoldText } from '../../../services/formatting';

const Container = styled.div`
  position: relative;
  padding-top: 60px;

  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0px 22px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

const Title = styled.div`
  font-family: Roboto;
  font-size: 96px;
  color: ${colors.black};
  text-align: left;

  @media (max-width: ${tabletThresholdPixels}) {
    width: unset;
    font-size: 36px;
    line-height: 39px;
  }
`;

const Description = styled.p`
  font-family: Roboto;
  font-size: 18px;
  line-height: 30px;
  color: ${colors.black};
  text-align: left;
  margin-top: 40px;
  margin-bottom: 20px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 18px;
    line-height: 39px;
    margin-top: 10px;
  }
`;

const TableContainer = styled.div`
  @media (max-width: ${tabletThresholdPixels}) {
    overflow-x: auto;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 12px;
  }
`;

const Header = styled.thead`
  height: 40px;
  margin-bottom: 5px;
`;

const HeaderCell = styled.span`
  background-color: ${colors.black};
  color: ${colors.white};
  border-radius: 12px;
  padding: 2px 20px;
  text-transform: uppercase;
  margin-bottom: 5px;
`;

const TableRow = styled.tr`
  background-color: ${colors.beige500};
  padding: 10px 20px;
  margin-bottom: 5px;
`;

const Cell = styled.td`
  padding: 5px;
  text-align: center;
`;

export default function RowTable({
  title, description, table: { headers, rows },
}) {
  const { t } = useTranslation();
  return (
    <Container>
      <Title>{t(title)}</Title>
      <Description>{t(description)}</Description>
      <TableContainer>
        <Table>
          <Header>
            <tr>
              {headers.map((header) => (
                <th key={header}>
                  {header ? <HeaderCell>{t(header)}</HeaderCell> : null}
                </th>
              ))}
            </tr>
          </Header>
          <tbody>
            {rows.map((row) => (
              <TableRow key={row[0]}>
                {row.map((cell, index) => (
                  <Cell key={cell}>
                    {cell.split('\n').map((text) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <span key={`${text}_${index}`}>
                        {toFormattedBoldText(t(text))}
                        <br />
                      </span>
                    ))}
                  </Cell>
                ))}
              </TableRow>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </Container>
  );
}

RowTable.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  table: PropTypes.shape({
    headers: PropTypes.arrayOf(PropTypes.string).isRequired,
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  }).isRequired,
};
